var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"flag",staticStyle:{"background-image":"url(/NO.png)"},attrs:{"alt":"NO"}}),_vm._v("NO ")])}]

export { render, staticRenderFns }